// Create a comment
export const createComment = async (apiCall, postId, content, parentCommentId = null, mentions = []) => {
  try {
    const response = await apiCall(`/api/comments/${postId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        content,
        parentCommentId,
        mentions
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      comment: data.data.comment
    };
  } catch (error) {
    throw error;
  }
};

// Get comments for a post
export const getPostComments = async (apiCall, postId, limit = 20, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/comments/${postId}/comments?${params.toString()}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      comments: data.data.comments || [],
      nextCursor: data.data.nextCursor || null,
      hasMore: data.data.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};

// Get replies for a comment
export const getCommentReplies = async (apiCall, commentId, limit = 5, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/comments/${commentId}/replies?${params.toString()}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      replies: data.data.replies || [],
      nextCursor: data.data.nextCursor || null,
      hasMore: data.data.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};

// Delete a comment
export const deleteComment = async (apiCall, commentId) => {
  try {
    const response = await apiCall(`/api/comments/${commentId}`, {
      method: 'DELETE'
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      deletedReplyIds: data.data.deletedReplyIds || [],
      newCommentsCount: data.data.newCommentsCount,
      isReply: data.data.isReply,
      parentCommentId: data.data.parentCommentId
    };
  } catch (error) {
    throw error;
  }
};

// Like a comment
export const likeComment = async (apiCall, commentId) => {
  try {
    const response = await apiCall(`/api/comments/${commentId}/like`, {
      method: 'POST'
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      likesCount: data.data.likesCount
    };
  } catch (error) {
    throw error;
  }
};

// Unlike a comment
export const unlikeComment = async (apiCall, commentId) => {
  try {
    const response = await apiCall(`/api/comments/${commentId}/unlike`, {
      method: 'DELETE'
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      likesCount: data.data.likesCount
    };
  } catch (error) {
    throw error;
  }
};